exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reset-password .body[data-v-28a816b2]{max-width:360px;margin:0 auto}", ""]);

// exports
